import React, { useState, useEffect } from 'react';
import './ConfirmModal.css';

export default function InputModal({ isOpen, title, fields, onSubmit, onCancel, submitText = 'Подтвердить', cancelText = 'Отмена' }) {
  const [values, setValues] = useState({});

  useEffect(() => {
    if (isOpen) {
      const initial = {};
      fields.forEach(f => { initial[f.name] = f.defaultValue ?? ''; });
      setValues(initial);
    }
    // Намеренно не включаем `fields` в зависимости: массив создаётся inline при каждом
    // ре-рендере родителя и сбрасывал бы введённый текст на каждый WS-апдейт.
    // Инициализация нужна только когда modal открывается (isOpen: false → true).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSubmit(values);
  };

  return (
    <div className="confirm-modal-backdrop" onClick={onCancel}>
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        {title && <p className="confirm-modal-message" style={{ fontWeight: 600, marginBottom: 16 }}>{title}</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
          {fields.map(f => (
            <div key={f.name} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {f.label && <label style={{ color: '#9da5b4', fontSize: 13 }}>{f.label}</label>}
              <input
                type={f.type || 'text'}
                placeholder={f.placeholder || ''}
                value={values[f.name] ?? ''}
                onChange={e => handleChange(f.name, e.target.value)}
                autoFocus={f.autoFocus}
                style={{
                  background: '#141724',
                  border: '1px solid #2e3347',
                  borderRadius: 6,
                  padding: '8px 12px',
                  color: '#cfd2da',
                  fontSize: 14,
                  outline: 'none',
                }}
                onKeyDown={e => { if (e.key === 'Enter' && fields.length === 1) handleSubmit(); }}
              />
            </div>
          ))}
        </div>
        <div className="confirm-modal-actions">
          <button className="confirm-modal-cancel" onClick={onCancel}>{cancelText}</button>
          <button className="confirm-modal-confirm" onClick={handleSubmit}>{submitText}</button>
        </div>
      </div>
    </div>
  );
}
